import styled from "@emotion/styled/macro";
import * as colors from "styles/colors";

const CircleButton = styled.button({
  borderRadius: "30px",
  padding: "0",
  width: "40px",
  fontSize: "30px",
  outline: "none",
  height: "40px",
  lineHeight: "1",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  background: colors.white,
  color: colors.gray700,
  border: `1px solid ${colors.gray100}`,
  cursor: "pointer",
});

export default CircleButton;
